// external
import { Component, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';

// models, types
import { CardSize } from '@/interfaces/Card';
import { ICallToAction } from '@/interfaces/CallToActionTypes';
import { Partner } from '@/interfaces/Partner';
import { Tab } from '@/interfaces/Tab';
import { VuexAction } from '@/@types/index.d';

// store
import {
	GET_CURRENT_MXR_RETAILER,
	GET_IS_TAKEOVER,
	SELECT_TAB,
	GET_SIZE,
	GET_SELECTED_TAB,
	GET_TABS,
	GET_TAB_CTA,
	SET_SELECTED_TAB_INDEX,
	GET_TAB_CLICK_REPORT,
	SEND_REPORT,
} from '@/store/types';

// components
import { IReport } from '@/interfaces/IReport';
import ProductShoppingList from './components/product-shopping-list/ProductShoppingList.vue';
import ShoppingList from './components/shopping-list/ShoppingList.vue';
import TabContent from './components/tab-content/TabContent.vue';
import MxrRetailer from '@/interfaces/MxrRetailer';

@Component({
	components: {
		ProductShoppingList,
		ShoppingList,
		TabContent,
	},
})
export default class Tabs extends Vue {
	@Getter(GET_SELECTED_TAB) getSelectedTab!: Tab;

	@Getter(GET_TABS) getTabs!: string[];

	@Getter(GET_TAB_CTA) getTabCta!: ICallToAction;

	@Getter(GET_SIZE) getSize!: CardSize;

	@Getter(GET_IS_TAKEOVER) getIsTakeOver!: boolean;

	@Getter(GET_CURRENT_MXR_RETAILER) getCurrentMxrRetailer!: MxrRetailer;

	@Getter(GET_TAB_CLICK_REPORT) getTabClickReport!: IReport;

	@Action(SELECT_TAB) selectTab!: VuexAction<Tab>;

	@Action(SET_SELECTED_TAB_INDEX) setTabIndex!: VuexAction<number>;

	@Action(SEND_REPORT) sendReport!: VuexAction<IReport>;

	async chooseTab(tab: number) {
		let incomingTab: Tab = Tab.Tab1;
		switch (tab) {
			case 1:
				incomingTab = Tab.Tab1;
				break;
			case 2:
				incomingTab = Tab.Tab2;
				break;
			case 3:
				incomingTab = Tab.Tab3;
				break;
			default:
				incomingTab = Tab.Tab1;
		}
		await this.selectTab(incomingTab);
		await this.setTabIndex(tab);
		this.sendReport(this.getTabClickReport);
	}

	get tab1(): string {
		return this.getTabs.length >= 1 ? this.getTabs[0] : '';
	}

	get tab2(): string {
		return this.getTabs.length >= 2 ? this.getTabs[1] : '';
	}

	get tab3(): string {
		return this.getTabs.length >= 3 ? this.getTabs[2] : '';
	}

	get tab1Selected(): boolean {
		return this.getSelectedTab === Tab.Tab1;
	}

	get tab2Selected(): boolean {
		return this.getSelectedTab === Tab.Tab2;
	}

	get tab3Selected(): boolean {
		return this.getSelectedTab === Tab.Tab3;
	}

	get currentTabName(): string {
		if (this.tab1Selected) {
			return this.tab1;
		}

		if (this.tab2Selected) {
			return this.tab2;
		}

		if (this.tab3Selected) {
			return this.tab3;
		}

		return '';
	}

	get partner(): Partner {
		return this.getTabCta.partner;
	}

	get isWalmart() {
		return this.partner === Partner.WALMART;
	}
}
